import { render, staticRenderFns } from "./useragreement.vue?vue&type=template&id=67ccf980&"
import script from "./useragreement.vue?vue&type=script&lang=js&"
export * from "./useragreement.vue?vue&type=script&lang=js&"
import style0 from "./useragreement.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports